import { Button, Grid, TextField } from "@mui/material";
import React, { useState, useContext } from "react";
import { StoresContext } from "contexts";
import SearchSubscriptionMessage from "./search-subscription-message";

const SearchCompanyByNr = ({ type }) => {
  const {
    applicationStore: { search },
  } = useContext(StoresContext);

  const [insz, setInsz] = useState("");

  return (
    <form
      autoComplete="off"
      onSubmit={(event) => {
        event.preventDefault();
        if (insz.length > 0) {
          console.log("searchCompanyByNumber", type, insz);
          search.searchCompanyByNumber(type, insz);
        }
      }}
    >
      <Grid container spacing={2} direction="column" alignItems="stretch">
        <SearchSubscriptionMessage type={type} />

        <Grid item>
          <TextField required id="standard-required" label="Ondernemingsnummer" variant="outlined" fullWidth onChange={(event) => setInsz(event.target.value)} />
        </Grid>
        <Grid item>
          <Button type="submit" variant="outlined" fullWidth data-test-id="btn-zoekop-companynumber">
            Zoek op
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default SearchCompanyByNr;
